import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import FormFileComponent from './js/form-file.component';

ComponentsFactory.getInstance().define('form-file', FormFileComponent);
